import { ToggleButton, ToggleButtonGroup } from 'ui';

import { CompanySourceEnum, type CompanySourceType } from '../../enums';

type Props = {
  onTradeCompanyTypeChange: (tradeCompanyType: CompanySourceType) => void;
  tradeCompanyType: CompanySourceType;
};

export const CompanySourceToggleButton = ({ tradeCompanyType, onTradeCompanyTypeChange }: Props) => {
  return (
    <ToggleButtonGroup
      value={tradeCompanyType}
      exclusive
      onChange={(_, newTradeCompanyType) => onTradeCompanyTypeChange(newTradeCompanyType)}
      fullWidth
    >
      <ToggleButton value={CompanySourceEnum.GROUND_CONTROL} color="primary">
        Ground Control company
      </ToggleButton>
      <ToggleButton value={CompanySourceEnum.HUBSPOT} color="primary">
        Hubspot lead
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
